//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BScroll from 'better-scroll'
import { mapState } from 'vuex'
export default {
    data() {
        return {
            queryItemList: []
        }
    },
    computed: {
        ...mapState([
            'ownerView',
        ]),
    },
    created() {},
    mounted() {
        this.$nextTick(() => {
            // this.queryScroll();
        })
    },
    methods: {
        GoMore() {
            this.$router.push('/myinquiry')
        },
        visitedQuery(id) {
            this.$http
                .get(`${this.$store.state.origin}/api/query/v2/getList?ownerId=${id}`)
                .then(res => {
                    var result = res.body.result
                    var queryItems = result.filter(item => {
                        return (
                            item.queryStatus != 'Solved' && item.queryStatus != 'Unsolved'
                        )
                    })
                    var queryItems = queryItems.sort((a, b) => {
                        var T1 = a.paidOrder.paidTime
                        var T2 = b.paidOrder.paidTime
                        return T1 - T2
                    })
                    this.queryItemList = queryItems
                    if(queryItems.length>0){
                        this.queryItemList = queryItems.length > 0 && queryItems.length < 3? queryItems : [queryItems[0], queryItems[1], queryItems[2]]
                        this.$nextTick(() => {
                            this.queryScroll()
                        })
                    }
                })
        },
        queryScroll() {
            let width =
                1 * document.body.clientWidth * this.queryItemList.length + 100
            this.$refs.Box.style.width = width + 'px'
            // this.$nextTick 是一个异步函数，为了确保 DOM 已经渲染
            this.$nextTick(() => {
                if (!this.scroll) {
                    this.scroll = new BScroll(this.$refs.queryWapper, {
                        startX: 0,
                        click: true,
                        scrollX: true,
                        // 忽略竖直方向的滚动
                        scrollY: false,
                        eventPassthrough: 'vertical'
                    })
                } else {
                    this.scroll.refresh()
                }
            })
        },
        GoDetail(id) {
            GLOBAL.sign(this.ownerView.id, 'homePage-toQueryDetail','homePage')
            this.$router.push({ path: '/query/queryDetail', query: { id: id } })
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/home/progressQuery.vue